import { LocationSelect } from '@/modules/salary/filters/desktop/location-select'
import { SpecialtySelect } from '@/modules/salary/filters/desktop/specialty-select'
import { JobTypeSelect } from '@/modules/salary/filters/desktop/job-type-select'
import { Search } from 'lucide-react'
import { Button } from '@/components/ui/deprecated-button'
import { useFormContext } from 'react-hook-form'
import LoadingSpinner from '@/components/ui/loading-spinner'
import { ProfessionSelect } from '@/modules/salary/filters/desktop/profession-select'
import { getFilterControlValues } from '@/modules/salary/filters/filter-utils'
import { SalaryFilterControls } from '@/modules/salary/types'
import { SalaryFilterParam } from '../../constants'
import { SalaryFilterControl } from '../../constants'

const FilterDivider = () => <div className="w-px h-full bg-background-muted" />

export function FiltersDesktop({
  onApplyFilters,
  loading,
  isAuthenticated,
}: {
  onApplyFilters: (fields: Partial<SalaryFilterControls>) => void
  loading: boolean
  isAuthenticated: boolean
}) {
  const { handleSubmit, formState, getValues, watch } =
    useFormContext<SalaryFilterControls>()
  const isDirty = formState.isDirty
  const values = watch()

  const onValueChanged = () => {
    const values = getValues()
    const specialtyValue = values[SalaryFilterControl.specialty]
    // https://marithealth.slack.com/archives/C05AYQNK0R3/p1735968392498619
    if (specialtyValue === undefined) {
      // we check only for undefined. If it is null, it is
      // an intentional programatic reset.
      // Check for setValue(SalaryUrlParams.specialty, null)
      return
    }
    onApplyFilters(getFilterControlValues(values))
  }

  return (
    <div
      className="flex items-center bg-background-primary shadow pl-4 pr-2 rounded-3xl w-full lg:w-[940px] \
      border border-border-muted"
    >
      <ProfessionSelect
        name={SalaryFilterControl.profession}
        onSelectProfession={onValueChanged}
        selectClassName="py-2 pl-0"
      />
      <FilterDivider />
      <SpecialtySelect
        name={SalaryFilterControl.specialty}
        professionSlug={values.profession}
        onSelectSpecialty={onValueChanged}
        isAuthenticated={isAuthenticated}
        isLoading={loading}
      />
      <FilterDivider />
      <LocationSelect
        name={SalaryFilterControl.state}
        onSelectLocation={onValueChanged}
      />
      <FilterDivider />
      <JobTypeSelect
        name={SalaryFilterParam.jobType}
        onSelectJobType={onValueChanged}
      />
      <Button
        customType="icon"
        size="sm"
        className="ml-4"
        onClick={() => {
          if (isDirty) {
            handleSubmit(onApplyFilters)()
          }
        }}
        isDisabled={loading}
      >
        {loading ? (
          <LoadingSpinner className="w-4 h-4" />
        ) : (
          <Search className="w-4 h-4" />
        )}
      </Button>
    </div>
  )
}
